import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AuthInfoService } from '../../core/auth-info/auth-info.service';
import { resolveAuthInfo } from '../../core/auth-info/auth-info.resolver';
import { RevisorRiskComponent } from './revisor-risk/revisor-risk.component';
import { RevisorMeasureComponent } from './revisor-measure/revisor-measure.component';
import { DashboardService } from '../dashboard/dashboard.service';
import {
  resolveDashboardEvaluation,
  resolveDashboardRevisor,
} from '../dashboard/dashboard.resolver';

export const REVISOR_STATES: Ng2StateDeclaration[] = [
  {
    name: 'app.revisor',
    redirectTo: 'app.revisor.risk',
    url: '/revisor',
    params: {
      security: {
        enabled: true,
        roles: [],
      },
      style: {
        feedback: true,
        hasMainMenu: true,
        hasSubMenu: true,
        hasSideNav: false,
      },
    },
    resolve: [
      {
        token: 'dashboardRevisor',
        deps: [DashboardService],
        resolveFn: resolveDashboardRevisor,
      },
      {
        token: 'authInfo',
        deps: [AuthInfoService],
        resolveFn: resolveAuthInfo,
      },
    ],
  },
  {
    name: 'app.revisor.risk',
    views: {
      '$default@app': {
        component: RevisorRiskComponent,
      },
    },
    url: '/risk',
  },
  {
    name: 'app.revisor.measure',
    views: {
      '$default@app': {
        component: RevisorMeasureComponent,
      },
    },
    url: '/measure',
  },
];
